import React from 'react';
import {Col, Row, Button} from 'reactstrap';

const PopupButtonAsLinkComponent = (props) => {
  return (
    <Row>
      <Col>
        <Button color='link' className='newPurple popup-btn-as-link w-100' onClick={() => props.onClick()}>
          {props.text}
        </Button>
      </Col>
    </Row>
  );
};

export default PopupButtonAsLinkComponent;
